import { Select } from "antd";
import { FC } from "react";
import { Dow } from "../../../generated/graphql";
import { formatDay } from "../../utils/dayUtils";

interface WeekdaySelectProps {
  value?: Dow | null;
  onSelect: (day: Dow | null) => void;
  placeholder?: string;
  disabled?: boolean;
  fill?: boolean;
  small?: boolean;
}

// Day options for select - using the utility function for consistency
const DAY_OPTIONS = [
  { value: Dow.Mon, label: formatDay(Dow.Mon) || "Monday" },
  { value: Dow.Tue, label: formatDay(Dow.Tue) || "Tuesday" },
  { value: Dow.Wed, label: formatDay(Dow.Wed) || "Wednesday" },
  { value: Dow.Thu, label: formatDay(Dow.Thu) || "Thursday" },
  { value: Dow.Fri, label: formatDay(Dow.Fri) || "Friday" },
  { value: Dow.Sat, label: formatDay(Dow.Sat) || "Saturday" },
  { value: Dow.Sun, label: formatDay(Dow.Sun) || "Sunday" },
];

export const WeekdaySelect: FC<WeekdaySelectProps> = ({
  value,
  onSelect,
  placeholder = "Select day",
  disabled = false,
  fill = false,
  small = false,
}) => {
  return (
    <Select
      placeholder={placeholder}
      value={value || undefined}
      onChange={(val) => onSelect(val ?? null)}
      disabled={disabled}
      allowClear
      onClear={() => onSelect(null)}
      size={small ? "small" : "middle"}
      style={fill ? { width: "100%" } : { minWidth: 150 }}
      options={DAY_OPTIONS}
    />
  );
};
